import { useEffect } from 'react';
import { analytics, Tracker } from './AnalyticsRegistery';
import { createPendoTracker } from './pendoTracker';
type TrackerConfig = {
  userId?: string;
  accountId?: string;
  apiKey?: string;
  isFoundry?: boolean;
};
export const useAnalytics = ({ userId, accountId, apiKey, isFoundry }: TrackerConfig) => {
  useEffect(() => {
    if (userId && accountId) {
      const pendo = createPendoTracker(apiKey, userId, accountId, isFoundry);
      analytics.register(pendo as Tracker);
    }
    return () => {
      analytics.teardownAll();
    };
  }, [userId, accountId, apiKey]);
};
